import { CallMeTheme } from "@acin.reactjs/acin-ui/callMe";
import { applyIconColor, ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

const callMeTheme = (theme: DefaultTheme): ComponentCSSStyle<CallMeTheme> => ({
  root: {
    backgroundColor: "transparent",
    boxShadow: "0px 16px 32px -12px  #00000029",
  },
  trigger: {
    root: {
      backgroundColor: theme.palette.secondary[500],
    },
    text: {
      color: theme.palette.common.black,
    },
    icon: {
      ...applyIconColor(theme.palette.common.black),
    },
  },
  steps: {
    closeIcon: {
      ...applyIconColor(theme.palette.common.black),
    },
    intro: {
      root: {
        backgroundColor: theme.palette.secondary[500],
      },
      title: {
        color: theme.palette.common.black,
      },
      description: {
        color: theme.palette.common.black,
      },
      icon: {
        ...applyIconColor(theme.palette.secondary[100]),
        "& [stroke]:not([stroke='none'])": {
          stroke: theme.palette.secondary[500],
        },
      },
    },
    callMe: {
      content: {
        root: {
          "& button": {
            backgroundColor: theme.palette.secondary[500],

            "&:hover": {
              backgroundColor: theme.palette.secondary[600],
            },

            "&:active": {
              backgroundColor: theme.palette.secondary[700],
            },
          },
        },
        form: {
          input: {
            focused: {
              container: {
                boxShadow: `0 0 0 2px ${theme.palette.secondary[100]}`,
                border: `1px solid ${theme.palette.greys[200]}`,
              },
            },
          },
          checkbox: {
            input: {
              "&:focus-within, focus": {
                boxShadow: `0 0 0 2px ${theme.palette.secondary[100]} !important`,
              },
            },
            icon: {
              root: {
                backgroundColor: theme.palette.secondary[500],
              },
            },
          },
        },
      },
    },
    success: {
      root: {
        backgroundColor: theme.palette.secondary[500],
      },
      title: {
        color: theme.palette.common.black,
      },
      description: {
        color: theme.palette.common.black,
      },
      icon: {
        ...applyIconColor(theme.palette.secondary[100]),
      },
    },
  },
});

export default callMeTheme;
